import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@material-ui/core/'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import Collapse from '../../../../../../components/UI/Collapse/Collapse'

const useStyles = makeStyles({
  table: {
    minWidth: 500
  }
})

function KpiTable(props) {
  const classes = useStyles()

  let data = null
  if (props.dataKpi) {
    data = Object.values(props.dataKpi).map(item => {
      return {
        perspective: item.item.perspective.perspective_name,
        kpi_name: item.item.item_name,
        target: item.target_value,
        uom: item.item.uom.uom_name,
        actual: item.actual_value,
        percent_achievement: item.percent_achievement,
        weight: item.weight_percent,
        weight_score: item.weight_score
      }
    })
  }

  return (
    <React.Fragment>
      <Collapse title={props.title || ''}>
        <TableContainer component={Paper}>
          <Table className={classes.table} stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>{props.translate('perspective')}</TableCell>
                <TableCell>{props.translate('kpiName')}</TableCell>
                <TableCell>{props.translate('target')}</TableCell>
                <TableCell>{props.translate('uom')}</TableCell>
                <TableCell>{props.translate('percentAchievement')}</TableCell>
                <TableCell>{props.translate('weight')}</TableCell>
                <TableCell>{props.translate('weightScore')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row?.perspective}</TableCell>
                  <TableCell>{row?.kpi_name}</TableCell>
                  <TableCell>{row?.target}</TableCell>
                  <TableCell>{row?.uom}</TableCell>
                  <TableCell>{row?.percent_achievement}</TableCell>
                  <TableCell>{row?.weight}</TableCell>
                  <TableCell>{row?.weight_score}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Collapse>
    </React.Fragment>
  )
}

export default withTranslate(KpiTable)
